import { Box, Text, useToast } from "@chakra-ui/react";
import { YearSelector } from "../../../../components";
import * as React from "react";
import { showErrorToast } from "../../../../utils";
import { useGetScopeOneConversionFactors } from "../../../../hooks/query/conversion-factors";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { mapScopeOneFactorsData } from "../helpers";
import { DataTable } from "../../../../components/DataTable";

function ScopeOneFactorsTab({ selectedYear, setSelectedYear }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "conversionFactors.headers"
  });
  const { t: globalTranslation } = useTranslation("translation");
  const toast = useToast();

  const [scopeOneFactorsData, setScopeOneFactorsData] = useState([]);

  const {
    isFetching
  } = useGetScopeOneConversionFactors({
    year: selectedYear
  }, {
    onSuccess: (data) => {
      if (data && data.length > 0) {
        setScopeOneFactorsData(mapScopeOneFactorsData(data));
      } else {
        setScopeOneFactorsData([]);
      }
    },
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  const columns = useMemo(() => {
    return [
      {
        header: t("consumptionType"),
        accessorKey: "consumptionType",
        size: 150
      },
      {
        header: t("measurementUnit"),
        accessorKey: "measurementUnit",
        size: 100
      },
      {
        header: t("conversionFactor"),
        accessorKey: "conversionFactor",
        size: 200,
        enableColumnFilter: false
      }
    ];
  }, [t]);

  return (
    <Box>
      <YearSelector selectedYear={selectedYear} handleYearSelection={(value) => setSelectedYear(value)} />
      {!scopeOneFactorsData || scopeOneFactorsData.length === 0 ?
        <Text fontSize="lg" fontWeight="bold">
          {globalTranslation("noDataAvailable")}
        </Text> :
        <DataTable
          data={scopeOneFactorsData}
          columns={columns}
          isLoading={isFetching}
          enableFilters={true}
        />
      }
    </Box>
  );
}

export default ScopeOneFactorsTab;